
<template>
  <div>
    <v-dialog
      persistent
      v-model="openDialogDetails"
      width="1100"
      style="z-index: 1"
    >
      <v-card style="border-radius: 10px; padding: 20px !important">
        <v-icon @click="close" class="dp-icon-modal">mdi-close</v-icon>
        <v-container>
          <!-- title content -->
          <v-row>
            <v-col>
              <p class="dp-title-modal" style="text-align: center">
                Detalle de orden de compra
                <span
                  style="margin-top: 12px; margin-left: 15px"
                  :class="`status-order-span status-order-background-color-${statusOrder}`"
                >
                  {{ statusOrder }}
                </span>
              </p>
            </v-col>
          </v-row>
          <hr style="height: 1px; background-color: #ffce00; border: none" />
          <!-- description content -->
          <v-row>
            <v-col cols="12" sm="6">
              <div>
                <!-- start item id -->
                <div class="status-content-flex">
                  <div class="status-content-fixed">
                    <p
                      style="
                        font-family: 'Poppins', sans-serif;
                        font-weight: 600;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      ID
                    </p>
                  </div>
                  <div class="status-content-restant">
                    <p
                      style="
                        color: #b7b7b7;
                        font-family: 'Poppins', sans-serif;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      {{ idOrder }}
                    </p>
                  </div>
                </div>
                <!-- end item id -->
                <!-- start item proyecto -->
                <div class="status-content-flex">
                  <div class="status-content-fixed">
                    <p
                      style="
                        font-family: 'Poppins', sans-serif;
                        font-weight: 600;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      Proyecto
                    </p>
                  </div>
                  <div class="status-content-restant">
                    <p
                      style="
                        color: #b7b7b7;
                        font-family: 'Poppins', sans-serif;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      {{ proyecto }}
                    </p>
                  </div>
                </div>
                <!-- end item proyecto -->
                <!-- start item categoria -->
                <div class="status-content-flex">
                  <div class="status-content-fixed">
                    <p
                      style="
                        font-family: 'Poppins', sans-serif;
                        font-weight: 600;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      Categoría
                    </p>
                  </div>
                  <div class="status-content-restant">
                    <p
                      style="
                        color: #b7b7b7;
                        font-family: 'Poppins', sans-serif;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      {{ categoria }}
                    </p>
                  </div>
                </div>
                <!-- end item categoria -->
                <!-- start item proveedor -->
                <div class="status-content-flex">
                  <div class="status-content-fixed">
                    <p
                      style="
                        font-family: 'Poppins', sans-serif;
                        font-weight: 600;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      Proveedor
                    </p>
                  </div>
                  <div class="status-content-restant">
                    <p
                      style="
                        color: #b7b7b7;
                        font-family: 'Poppins', sans-serif;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      {{ proveedor }}
                    </p>
                  </div>
                </div>
                <!-- end item proveedor -->
                <!-- start item metodo de pago -->
                <div class="status-content-flex">
                  <div class="status-content-fixed">
                    <p
                      style="
                        font-family: 'Poppins', sans-serif;
                        font-weight: 600;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      Método de pago
                    </p>
                  </div>
                  <div class="status-content-restant">
                    <p
                      style="
                        color: #b7b7b7;
                        font-family: 'Poppins', sans-serif;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      {{ metodoPago }}
                    </p>
                  </div>
                </div>
                <!-- end item metodo de pago -->
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <div>
                <!-- start item fecha de creacion -->
                <div class="status-content-flex">
                  <div class="status-content-fixed">
                    <p
                      style="
                        font-family: 'Poppins', sans-serif;
                        font-weight: 600;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      Fecha de creación
                    </p>
                  </div>
                  <div class="status-content-restant">
                    <p
                      style="
                        color: #b7b7b7;
                        font-family: 'Poppins', sans-serif;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      {{ fechaCreacionOrder }}
                    </p>
                  </div>
                </div>
                <!-- end item fecha de creacion -->
                <div class="status-content-flex">
                  <div class="status-content-fixed">
                    <p
                      style="
                        font-family: 'Poppins', sans-serif;
                        font-weight: 600;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      # de elementos
                    </p>
                  </div>
                  <div class="status-content-restant">
                    <p
                      style="
                        color: #b7b7b7;
                        font-family: 'Poppins', sans-serif;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      {{ itemsRequestPerMaterial.length }}
                    </p>
                  </div>
                </div>
                <!-- end item amoount of eelements  -->
                <!-- start item comentarios -->
                <div class="status-content-flex">
                  <div class="status-content-fixed">
                    <p
                      style="
                        font-family: 'Poppins', sans-serif;
                        font-weight: 600;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      Notas al proveedor:
                    </p>
                  </div>
                  <div class="status-content-restant">
                    <p
                      style="
                        color: #b7b7b7;
                        font-family: 'Poppins', sans-serif;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      {{
                        comentarios.trim() === ""
                          ? '"No hay notas adicionales para esta orden de compra."'
                          : comentarios
                      }}
                    </p>
                  </div>
                </div>
                <!-- end item comentarios -->
                <!-- start item comentarios -->
                <div class="status-content-flex">
                  <div class="status-content-fixed">
                    <p
                      style="
                        font-family: 'Poppins', sans-serif;
                        font-weight: 600;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      Notas internas
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on"> -->
                          <v-icon
                            style="
                              cursor: pointer;
                              font-size: 15px;
                              margin-bottom: 10px;
                              margin-left: 0px !important;
                            "
                            color="blue"
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-alert-circle</v-icon
                          >

                          <!-- </v-btn> -->
                        </template>
                        <span
                          >Estas notas no serán visibles por los proveedores ni
                          estarán presentes en la cotización generada.
                        </span>
                        <br />
                        <span
                          >Solo modificables en: Borrador y correcciones.</span
                        >
                      </v-tooltip>
                      :
                    </p>
                  </div>
                  <div class="status-content-restant">
                    <p
                      style="
                        color: #b7b7b7;
                        font-family: 'Poppins', sans-serif;
                        margin-bottom: 0;
                        font-size: 14px;
                      "
                    >
                      {{
                        comentariosInternos.trim() === ""
                          ? '"No hay notas internas definidas para esta orden de compra."'
                          : comentariosInternos
                      }}
                    </p>
                  </div>
                </div>
                <!-- end item comentarios -->
              </div>
            </v-col>
          </v-row>
          <br />
          <!-- table materials content -->
          <v-row>
            <v-col cols="12" sm="12">
              <div>
                <!-- Start simple table -->
                <v-card style="border-radius: 20px; padding: 20px !important">
                  <v-simple-table fixed-header height="210px">
                    <template>
                      <thead v-if="!bLoading">
                        <tr>
                          <th
                            style="
                              border-bottom: 3px solid #e4e4e4;
                              text-align: center !important;
                              white-space: nowrap;
                            "
                          >
                            Recibido

                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  style="top: -10px; cursor: pointer"
                                  v-bind="attrs"
                                  v-on="on"
                                  color="blue darken-1"
                                  >mdi-alert-circle</v-icon
                                >
                              </template>
                              <span
                                >Marcar o desmarcar los materiales
                                recibidos.</span
                              >
                            </v-tooltip>
                          </th>
                          <th
                            class="text-left"
                            style="border-bottom: 3px solid #e4e4e4"
                          >
                            Concepto
                          </th>
                          <th
                            class="text-left"
                            style="border-bottom: 3px solid #e4e4e4"
                          >
                            Cantidad
                          </th>
                          <th
                            class="text-left"
                            style="border-bottom: 3px solid #e4e4e4"
                          >
                            Cantidad recibida
                          </th>
                          <th
                            class="text-left"
                            style="border-bottom: 3px solid #e4e4e4"
                          >
                            Fecha de recepción
                          </th>
                          <th
                            class="text-left"
                            style="border-bottom: 3px solid #e4e4e4"
                          >
                            Unidad de medida
                          </th>
                          <th
                            class="text-left"
                            style="border-bottom: 3px solid #e4e4e4"
                          >
                            Precio unitario
                          </th>
                          <th
                            class="text-left"
                            style="border-bottom: 3px solid #e4e4e4"
                          >
                            Importe
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="!bLoading">
                        <tr
                          v-for="(item, index) in itemsRequestPerMaterial"
                          :key="index"
                        >
                          <td>
                            <v-checkbox
                              style="margin-left: 20px"
                              v-model="item.bReceived"
                              :key="item.sOrderMaterialId"
                              disabled
                            >
                            </v-checkbox>
                          </td>
                          <td class="text-left">{{ item.sMaterialName }}</td>
                          <td class="text-left">{{ item.dQuantity }}</td>
                          <td class="text-left">
                            {{ item.dQuantityReceived }}
                          </td>
                          <td class="text-left">{{ item.tReceivedDate }}</td>
                          <td class="text-left">{{ item.sMeasureUnitName }}</td>
                          <td class="text-left" style="white-space: pre">
                            ${{ mask(item.dUnitPrice) }} MXN
                          </td>
                          <td class="text-left" style="white-space: pre">
                            ${{ mask(item.dTotal) }} MXN
                          </td>
                        </tr>
                      </tbody>
                      <div v-show="bLoading">
                        <v-progress-linear
                          indeterminate
                          color="yellow darken-2"
                        ></v-progress-linear>
                        <div class="content-text-loading">
                          <p class="text-loading">
                            Cargando... Espere por favor
                          </p>
                        </div>
                      </div>
                    </template>
                  </v-simple-table>
                  <!-- <div
                    style="
                      display: flex;
                      justify-content: flex-end;
                      align-items: center;
                      padding-right: 20px;
                      margin-top: 10px;
                    "
                  >
                    <p
                      style="
                        font-family: 'Poppins', sans-serif;
                        font-size: 14px;
                        font-weight: 600;
                      "
                    >
                      SUBTOTAL
                      <span style="color: #63e3b2; margin-left: 10px"
                        >${{ mask(subtotal) }} MXN</span
                      >
                    </p>
                  </div> -->

                  <div class="mt-5">
                    <v-row>
                      <v-col class="text-end" cols="6">
                        <p
                          style="
                            font-family: 'Poppins', sans-serif;
                            font-size: 14px;
                            font-weight: 600;
                          "
                        >
                          SUBTOTAL RECIBIDO
                          <span style="color: #63e3b2; margin-left: 10px"
                            >${{ sumatoriaMaterialesRecibidos() }} MXN</span
                          >
                        </p>
                      </v-col>
                      <v-col class="text-end" cols="6">
                        <p
                          style="
                            font-family: 'Poppins', sans-serif;
                            font-size: 14px;
                            font-weight: 600;
                          "
                        >
                          SUBTOTAL
                          <span style="color: #63e3b2; margin-left: 10px"
                            >${{ mask(subtotal) }} MXN</span
                          >
                        </p>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
                <!-- End simple table -->
              </div>
            </v-col>
          </v-row>
          <br />
          <!-- button content -->
          <v-row>
            <v-col cols="12" sm="6">
              <div>
                <v-btn
                  @click="close"
                  x-large
                  color="black"
                  width="175"
                  outlined
                  class="text-Poppins"
                  style="
                    height: 50px;
                    font-size: 13px;
                    font-weight: 600;
                    border-radius: 5px;
                  "
                >
                  Cerrar
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" sm="6" class="text-right">
              <div>
                <v-btn
                  @click="downloadPurchaseOrder"
                  :loading="bLoadDownload"
                  x-large
                  width="220"
                  color="primary"
                  class="text-Poppins"
                  style="
                    height: 50px;
                    color: black;
                    box-shadow: 0px 20px 40px #00000029;
                    border-radius: 5px;
                    font-size: 13px;
                    font-weight: 600;
                    margin-left: 25px;
                  "
                >
                  Descargar orden de compra
                </v-btn>
                <v-btn
                  x-large
                  width="175"
                  color="primary"
                  class="text-Poppins"
                  style="
                    height: 50px;
                    color: black;
                    box-shadow: 0px 20px 40px #00000029;
                    border-radius: 5px;
                    font-size: 13px;
                    font-weight: 600;
                    margin-left: 25px;
                  "
                  :disabled="disableBtnDownloadDoc"
                  @click="downloadCotizacion"
                >
                  Descargar cotización
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "DetailsOCs",
  props: {
    openDialogDetails: {
      type: Boolean,
      default: false,
    },
    itemDetails: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      itemsRequestPerMaterial: [],
      statusOrder: "",
      subtotal: 0,
      idOrder: "",
      comentarios: "",
      comentariosInternos: "",
      categoria: "",
      proyecto: "",
      fechaCreacionOrder: "",
      proveedor: "",
      metodoPago: "",
      bLoadDownload: false,
      disableBtnDownloadDoc: false,
      bLoading: true,
    };
  },
  methods: {
    downloadCotizacion() {
      db.get(
        `${uri}/api/v1/purchase_order/order/${this.itemDetails.sPurchaseOrderId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("user-tk"),
            "content-type": "application/x-www-form-urlencoded;charset=utf-8",
          },
        }
      )
        .then((resp) => {
          if (resp.data.order.sQuoteKey !== "Sin documento por el momento.") {
            window.open(resp.data.order.sQuoteKey, "_blank");
          } else {
            const alert = {
              color: "red",
              text: "No existe un documento asociado a esta orden de compra.",
            };
            this.$store.commit("toggle_alert", alert);
          }
        })
        .catch((err) => {
          this.bLoading = false;
          const alert = {
            color: "red",
            text: err.response.data.message,
          };
          this.$store.commit("toggle_alert", alert);
        });
    },
    downloadPurchaseOrder() {
      this.bLoadDownload = true;
      // /api/v1/purchase_order/pdf/:sPurchaseOrderId
      db.get(
        `${uri}/api/v1/purchase_order/pdf/${this.itemDetails.sPurchaseOrderId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("user-tk"),
            "content-type": "application/x-www-form-urlencoded;charset=utf-8",
          },
        }
      )
        .then((resp) => {
          this.bLoadDownload = false;
          const alert = {
            color: "green",
            text: resp.data.message,
          };
          this.$store.commit("toggle_alert", alert);
          window.open(resp.data.pdfUrl);
        })
        .catch((err) => {
          this.bLoadDownload = false;
          const alert = {
            color: "red",
            text: err.response.data.message,
          };
          this.$store.commit("toggle_alert", alert);
        });
    },
    rechazarOrden() {
      this.close();
      this.$emit("openDialogDenyOrderFunction");
    },
    close() {
      this.$emit("close");
      this.loadingButtonOrdenCompra = false;
    },
    allData() {
      this.getMaterialResquest();
      this.disableBtnDownloadDoc = this.itemDetails.sQuoteKey == "";
      this.statusOrder = this.itemDetails.PurchaseOrderStatusRecords.sName;
      this.comentarios = this.itemDetails.sComments;
      this.comentariosInternos = this.itemDetails.sPrivateComments;
      this.proyecto = this.itemDetails.sProjectName;
      this.categoria = this.itemDetails.sCategoryName;
      this.proveedor = this.itemDetails.sSupplierName;
      this.metodoPago = this.itemDetails.sPaymentMethod;
      this.fechaCreacionOrder = this.itemDetails.created_at;
      this.idOrder = this.itemDetails.sPurchaseOrderId;
    },
    getMaterialResquest() {
      this.bLoading = true;
      // get material per request
      db.get(
        `${uri}/api/v1/purchase_order/materials/${this.itemDetails.sPurchaseOrderId}/1`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("user-tk"),
            "content-type": "application/x-www-form-urlencoded;charset=utf-8",
          },
          params: {
            // iPageNumber: "1",
            formatDate: true,
          },
        }
      )
        .then((resp) => {
          this.itemsRequestPerMaterial = resp.data.OrderMaterials.map((e) => {
            return {
              ...e,
              dQuantity: Number(e.dQuantity),
              dQuantityReceived:
                e.dQuantityReceived != null
                  ? Number(e.dQuantityReceived)
                  : "N/A",
              tReceivedDate:
                e.tReceivedDate != null
                  ? e.tReceivedDate.substring(0, 10)
                  : "N/A",
            };
          });
          this.sumatoriaMateriales();
          this.bLoading = false;
        })
        .catch((err) => {
          this.bLoading = false;
          const alert = {
            color: "red",
            text: err.response.data.message,
          };
          this.$store.commit("toggle_alert", alert);
        });
    },
    sumatoriaMaterialesRecibidos() {
      var sum = 0;
      for (let i = 0; i < this.itemsRequestPerMaterial.length; i++) {
        const element = this.itemsRequestPerMaterial[i];
        sum = sum + Number(element.dQuantityReceived) * element.dUnitPrice;
      }
      return this.mask(sum);
    },
    sumatoriaMateriales() {
      var sum = 0;
      for (let i = 0; i < this.itemsRequestPerMaterial.length; i++) {
        const element = this.itemsRequestPerMaterial[i];
        sum = sum + element.dQuantity * element.dUnitPrice;
      }
      this.subtotal = sum;
    },
    mask(price) {
      const nf = new Intl.NumberFormat("en-US");
      let number = nf.format(price);
      return price % 1 === 0 ? (number = number + ".00") : number;
    },
  },
  watch: {
    openDialogDetails: function () {
      if (this.openDialogDetails) {
        this.allData();
      }
    },
  },
  computed: {},
};
</script>
<style scoped>
.status-order-span {
  background-color: #8d8d8d;
  font-family: "Poppins", sans-serif;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  padding: 5px 15px;
  border-radius: 30px;
  position: absolute;
  margin-left: 5px;
  box-shadow: 0px 4px 8px #8d8d8d !important;
}

.status-content-flex {
  display: flex;
  width: 100%;
  margin-top: 10px;
}

.status-content-fixed {
  width: 190px;
}

.status-content-restant {
  width: calc(100% - 190px);
}

.status-order-span-color-Enviada {
  color: #79c6ff;
}

.status-order-span-color-Borrador {
  color: #ffca3b;
}

.status-order-span-color-Aprobada,
.status-order-span-color-Recibida {
  color: #97e6b6;
}

.status-order-span-color-Rechazada {
  color: #ff7d7d;
}

.status-order-span-color-Pagada {
  color: #97e6b6;
}

.status-order-span-color-Cancelada {
  color: #ff7d7d;
}

.status-order-background-color-Enviada {
  background-color: #79c6ff;
}

.status-order-background-color-Borrador {
  background-color: #ffca3b;
}

.status-order-background-color-Aprobada,
.status-order-background-color-Recibida {
  background-color: #97e6b6;
}

.status-order-background-color-Rechazada {
  background-color: #ff7d7d;
}

.status-order-background-color-Pagada {
  background-color: #97e6b6;
}

.status-order-background-color-Cancelada {
  background-color: #ff7d7d;
}
</style>